const getCompany = `query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      processes (limit: 500){
        items{
          id
          comments (limit: 100){
            items{
              id
            }
          }
          measureSets (limit: 100){
            items{
              id
            }
          }
          measures (limit: 100){
            items{
              id
            }
          }
        }
      }
      measureSets (limit: 100){
        items{
          id
          measures (limit: 100){
            items{
              id
            }
          }
        }
      }
    }
  }
`;

const getProcess = `query GetProcess($id: ID!) {
  getProcess(id: $id) {
    company {
      id
    }
    id
    seq_nr
    text_header
    comments (limit: 100){
      items{
        id
      }
    }
    measureSets (limit: 100){
      items{
        id
      }
    }
    measures (limit: 100){
      items{
        id
      }
    }
  }
}
`;

const getMeasureSet = `query GetMeasureSet($id: ID!) {
  getMeasureSet(id: $id) {
    company {
      id
    }
    id
    type
    seq_nr
    processes (limit: 500){
      items{
        id
      }
    }
    measures (limit: 100){
      items{
        id
      }
    }
  }
}
`;

const deleteCompany = `mutation DeleteCompany($input: DeleteCompanyInput!) {
  deleteCompany(input: $input) {
    id
  }
}`;
const deleteProcess = `mutation DeleteProcess($input: DeleteProcessInput!) {
  deleteProcess(input: $input) {
    id
  }
}`;
const deleteMeasureSet = `mutation DeleteMeasureSet($input: DeleteMeasureSetInput!) {
  deleteMeasureSet(input: $input) {
    id
  }
}`;
const deleteProcessMeasure = `mutation DeleteProcessMeasure($input: DeleteProcessMeasureInput!) {
  deleteProcessMeasure(input: $input) {
    id
  }
}`;
const deleteMeasureSetMeasure = `mutation DeleteMeasureSetMeasure($input: DeleteMeasureSetMeasureInput!) {
  deleteMeasureSetMeasure(input: $input) {
    id
  }
}`;
const deleteProcessMeasureSet = `mutation DeleteProcessMeasureSet($input: DeleteProcessMeasureSetInput!) {
  deleteProcessMeasureSet(input: $input) {
    id
  }
}`;
const deleteProcComment = `mutation DeleteProcComment($input: DeleteProcCommentInput!) {
  deleteProcComment(input: $input) {
    id
  }
}`;

import Amplify from "aws-amplify";
import API, { graphqlOperation } from "@aws-amplify/api";
import ChangeManager from "./ChangeManager";

export class SodaDeleteManager {
  constructor(mode, deletePlanCallback, updateCountsCallback, deleteDoneCallback) {
    this.mode = mode; // Company, Process, MeasureSet
    this.deletePlanCallback = deletePlanCallback;
    this.updateCountsCallback = updateCountsCallback;
    this.deleteDoneCallback = deleteDoneCallback;
    this.state = "init";
    this.id = null;
    this.fetchQuery = null;
    this.root = null;
    this.deleteLists = null;
    this.deleteListsIdx = 0;
    this.deleted_count = 0;
    this.deleting_entity = null;
    this.currentlyDeletingEntity = null;
    this.numberNextEntitiesToBeDeleted = 0;
    this.numberNextEntitiesAlreadyDeleted = 0;
    this.changeManager = new ChangeManager();
  }
  prepare(id) {
    if (this.state !== "init") {
      throw "WrongStatusError: Call to prepare() only allowed in init state.";
    }
    this.id = id;
    switch (this.mode) {
      case "Company":
        this.fetchQuery = getCompany;
        break;
      case "Process":
        this.fetchQuery = getProcess;
        break;
      case "MeasureSet":
        this.fetchQuery = getMeasureSet;
        break;
      default:
        raise("InvalidModeError");
    }
    var gqlop = graphqlOperation(this.fetchQuery, { id: this.id });
    API.graphql(gqlop).then(async (result) => {
      this.root = result.data[this.query_name];
      await this.prepareFunc(result);
      this.state = "prepared";
      this.deletePlanCallback(this.deleteLists);
      this.updateCountsCallback({
        total_count: this.total_count,
        deleted_count: this.deleted_count,
        deleting_entity: this.currentlyDeletingEntity,
        total_count_detail: this.numberNextEntitiesToBeDeleted,
        deleted_count_detail: this.numberNextEntitiesAlreadyDeleted,
      });
    });
  }
  get query_name() {
    return "get" + this.mode;
  }
  get prepareFunc() {
    return this["prepare" + this.mode];
  }
  get total_count() {
    return this.deleteLists.map((e) => e.entities.length).reduce((a, b) => a + b);
  }
  get deleted_message() {
    return this.mode.charAt(0).toLowerCase() + this.mode.slice(1);
  }
  delete() {
    if (this.state !== "prepared") {
      throw "WrongStatusError: Call to delete() only allowed in prepared state.";
    }
    this.deleteListsIdx = 0;
    this.state = "deleting";
    this.processNextDeleteList();
  }
  processNextDeleteList() {
    if (this.total_count == this.deleted_count) {
      this.onDeleted();
      return;
    }
    var dlist = this.deleteLists[this.deleteListsIdx];
    this.currentlyDeletingEntity = dlist.label;
    this.numberNextEntitiesToBeDeleted = dlist.entities.length;
    this.numberNextEntitiesAlreadyDeleted = 0;
    if (this.numberNextEntitiesToBeDeleted == 0) {
      this.deleteListProcessed();
    }
    if (dlist.mutation !== undefined) {
      // graphql mutation
      for (var e of dlist.entities) {
        var gqlOp = graphqlOperation(dlist.mutation, { input: { id: e.id } });
        API.graphql(gqlOp)
          .then((response) => {
            this.changeManager.recordDelete(this.company_id, dlist.changeLogEntityType, e, (res, err) => {
              res
                ? console.log(`logged ${dlist.changeLogEntityType} create`, res)
                : console.error(`error logging ${dlist.changeLogEntityType} create`, err, e);
            });
            this.entityDeleted(response);
          })
          .catch((err) => {
            this.abortDelete(err.errors[0].message);
          });
      }
    } else if (dlist.deletefunc !== undefined) {
      // document
      for (var fname of dlist.entities) {
        dlist
          .deletefunc(fname)
          .then((response) => {
            this.entityDeleted(response);
          })
          .catch((err) => {
            this.abortDelete(err.errors[0].message);
          });
      }
    }
  }
  abortDelete(err) {
    this.deleteDoneCallback({ success: false, error: err });
  }
  entityDeleted(response) {
    this.deleted_count += 1;
    this.numberNextEntitiesAlreadyDeleted += 1;
    if (this.numberNextEntitiesToBeDeleted == this.numberNextEntitiesAlreadyDeleted) {
      this.deleteListProcessed();
    }
    this.updateCounts();
  }
  deleteListProcessed() {
    this.deleteListsIdx += 1;
    this.processNextDeleteList();
  }
  updateCounts() {
    this.updateCountsCallback({
      total_count: this.total_count,
      deleted_count: this.deleted_count,
      deleting_entity: this.currentlyDeletingEntity,
      total_count_detail: this.numberNextEntitiesToBeDeleted,
      deleted_count_detail: this.numberNextEntitiesAlreadyDeleted,
    });
  }
  onDeleted() {
    this.state = "done";
    this.updateCounts();
    this.deleteDoneCallback({ success: true });
  }
  async prepareCompany() {
    var company = this.root;
    this.company_id = company.id;
    var documents = await Amplify.Storage.list(company.id + "/documents/", { level: "private" });
    this.deleteLists = [
      {
        label: "Kommentare",
        changeLogEntityType: "COMMENT",
        mutation: deleteProcComment,
        entities: company.processes.items.flatMap((proc) => proc.comments.items),
      },
      {
        label: "To-Dos",
        changeLogEntityType: "PROCESSMEASURE",
        mutation: deleteProcessMeasure,
        entities: company.processes.items.flatMap((proc) => proc.measures.items),
      },
      {
        label: "Verknüpfungen",
        changeLogEntityType: "PROCESSMEASURESET",
        mutation: deleteProcessMeasureSet,
        entities: company.processes.items.flatMap((proc) => proc.measureSets.items),
      },
      {
        label: "Einzelmaßnahmen",
        changeLogEntityType: "MEASURESETMEASURE",
        mutation: deleteMeasureSetMeasure,
        entities: company.measureSets.items.flatMap((ms) => ms.measures.items),
      },
      {
        label: "allgemeine TOMs",
        changeLogEntityType: "MEASURESET",
        mutation: deleteMeasureSet,
        entities: company.measureSets.items,
      },
      {
        label: "Verfahren",
        changeLogEntityType: "PROCESS",
        mutation: deleteProcess,
        entities: company.processes.items,
      },
      {
        label: "Unternehmen",
        changeLogEntityType: "COMPANY",
        mutation: deleteCompany,
        entities: [company],
      },
      {
        label: "Dokumente",
        deletefunc: (fname) => Amplify.Storage.remove(fname, { level: "private" }),
        entities: documents.map((e) => e.key),
      },
    ];
  }
  prepareProcess() {
    var process = this.root; //= result.data.getProcess
    this.company_id = process.company.id;
    this.deleteLists = [
      {
        label: "Kommentare",
        changeLogEntityType: "COMMENT",
        mutation: deleteProcComment,
        entities: process.comments.items,
      },
      {
        label: "To-Dos",
        changeLogEntityType: "PROCESSMEASURE",
        mutation: deleteProcessMeasure,
        entities: process.measures.items,
      },
      {
        label: "Verknüpfungen",
        changeLogEntityType: "PROCESSMEASURESET",
        mutation: deleteProcessMeasureSet,
        entities: process.measureSets.items,
      },
      {
        label: "Verfahren",
        changeLogEntityType: "PROCESS",
        mutation: deleteProcess,
        entities: [process],
      },
    ];
  }
  prepareMeasureSet() {
    var measureSet = this.root; //= result.data.getMeasureSet
    this.company_id = measureSet.company.id;
    this.deleteLists = [
      {
        label: "Einzelmaßnahmen",
        changeLogEntityType: "MEASURESETMEASURE",
        mutation: deleteMeasureSetMeasure,
        entities: measureSet.measures.items,
      },
      {
        label: "Verknüpfungen",
        changeLogEntityType: "PROCESSMEASURESET",
        mutation: deleteProcessMeasureSet,
        entities: measureSet.processes.items,
      },
      {
        label: "Allgemeine TOMs",
        changeLogEntityType: "MEASURESET",
        mutation: deleteMeasureSet,
        entities: [measureSet],
      },
    ];
  }
}
